module.exports = __webpack_public_path__ + "img/Youtube Icon - white.c47ab755.svg";